import { createContext } from 'react';
import { User } from 'users/types';

export const EditUserModalContext = createContext<{ open: (user: User) => void }>({ open: () => {} });
